import { FC } from 'react';

import { IcAddUserIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView } from '@gem/ui-kit';

import { useCallAddCustomPermissionsLinkPresenter } from './CallAddCustomPermissionsLink.presenter';
import styles from './CallAddCustomPermissionsLink.styles.m.css';
import { ICallAddCustomPermissionsLinkProps } from './CallAddCustomPermissionsLink.types';

export const CallAddCustomPermissionsLink: FC<ICallAddCustomPermissionsLinkProps> = (props) => {
  const { t } = useTranslation();
  const presenter = useCallAddCustomPermissionsLinkPresenter(props);

  return (
    <button
      className={styles.link}
      onClick={presenter.onClick}
    >
      <IconView
        Icon={IcAddUserIcon}
        className={styles.icon}
      />
      <span className={styles.text}>{t('call_add_custom_permissions')}</span>
    </button>
  );
};
